import React from 'react';
import { Button } from '../ui/button';
import { ShieldCheck } from 'lucide-react';
import { Reveal } from './Reveal';

export const PennylaneSection = () => (
  <section className="section-spacing bg-cream">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <Reveal>
        <div className="rounded-[2rem] bg-primary-blue text-white p-8 md:p-14 flex flex-col md:flex-row md:items-center gap-8 relative overflow-hidden">
          <ShieldCheck className="absolute -bottom-12 -right-8 w-64 h-64 text-white/5" />
          <div className="flex-1 relative">
            <p className="text-xs uppercase tracking-[0.25em] font-semibold text-warm-accent mb-4">Espace client sécurisé</p>
            <h2 className="font-heading text-2xl md:text-4xl font-light mb-3">Votre comptabilité en temps réel</h2>
            <p className="text-white/70 max-w-xl">
              Accédez à vos documents, factures et tableaux de bord 24h/24 via notre plateforme Pennylane.
            </p>
          </div>
          <Button asChild className="bg-white text-primary-blue hover:bg-warm-accent hover:text-white rounded-full px-8 py-6 text-base font-medium relative">
            <a href="https://app.pennylane.com" target="_blank" rel="noopener noreferrer" data-testid="pennylane-login" className="flex items-center gap-2">
              <img src="/pennylane-icon.png" alt="Pennylane" className="w-5 h-5" />
              Se connecter à Pennylane
            </a>
          </Button>
        </div>
      </Reveal>
    </div>
  </section>
);
